import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { CAMPAIGN_TYPE, NOTIFY } from "../based/Constants";
import TextArea from "../based/inputs/TextArea";
import Textbox from "../based/inputs/Textbox";
import TextNumber from "../based/inputs/TextNumber";
import TFUDatetime from "../based/inputs/TFUDatetime";
import TFUSelect from "../based/inputs/TFUSelect";
import Loading from "../based/Loading";
import { Notify } from "../based/Notify";
import CampaignServices from "../based/services/CampaignServices";
import Breadcum from "../layout/refactor/Breadcum/Breadcum";

const SaleType = {
    Undefined: 0,
    FixedPrice: 1,
    Percentage: 2,
};

const SaleTypeOptions = [
    {
        value: SaleType.FixedPrice,
        label: "Giá cố định",
    },
    {
        value: SaleType.Percentage,
        label: "Phần trăm",
    },
];

const initCampaignMegaDeal = {
    id: 0,
    index: 0,
    campaignId: 0,
    saleType: 0,
    saleValue: 0,
    minimumOrderValue: 0,
};

const initCampaign = {
    id: 0,
    title: null,
    shortLink: null,
    index: 1,
    showTime: new Date(),
    startTime: new Date(),
    endTime: new Date(new Date().setDate(new Date().getDate() + 1)),
    description: null,
    isActive: true,
    type: CAMPAIGN_TYPE.MEGA,
    campaignMegaDeals: [{ ...initCampaignMegaDeal }],
};

function EditCampaign(props) {
    const { id } = props.match.params;
    const [isLoading, setIsLoading] = useState(false);
    const [campaign, setCampaign] = useState(initCampaign);
    const history = useHistory();

    useEffect(() => {
        if (id > 0) getCampaign(id);
    }, [id]);

    const getCampaign = async (id) => {
        setIsLoading(true);
        const [err, data] = await CampaignServices.GetCampaignById(id, CAMPAIGN_TYPE.MEGA);
        if (!err && data) {
            let camp = data;
            if (camp && !camp.campaignMegaDeals) {
                camp.campaignMegaDeals = [{ ...initCampaignMegaDeal }];
            }
            camp.showTime = new Date(camp.showTime);
            camp.startTime = new Date(camp.startTime);
            camp.endTime = new Date(camp.endTime);
            setCampaign(camp);
        } else {
            setCampaign(initCampaign);
        }
        setIsLoading(false);
    };

    const _handleSave = async () => {
        setIsLoading(true);
        const [err, data] = await CampaignServices.AddOrUpdateCampaign(campaign);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, "Thành công", "Lưu thành công");
        } else {
            Notify(NOTIFY.ERROR, "Lỗi", "Có lỗi xảy ra. Vui lòng thử lại sau ít phút.");
        }
        setIsLoading(false);
    };

    return (
        <React.Fragment>
            <Loading show={isLoading} msg={"Đang tải dữ liệu"} />
            <Breadcum menu={["Trang chủ", "Chiến dịch khuyến mãi", "Thiết lập chiến dịch"]} title="Thiết lập chiến dịch" />
            <Wrapper>
                <section className="instruction-section">
                    <p className="">
                        Chiến dịch khuyễn mãi chỉ áp dụng cho các sản phẩm của shop.
                        <br />
                        Giá sẽ được giảm trực tiếp lên sản phẩm tại bước thanh toán.
                    </p>
                </section>
                <section className="overview-section">
                    <h6>Thông tin cơ bản</h6>
                    <div className="list-form">
                        <div className="form-group title">
                            <label htmlFor="" className="required">
                                Tên chiến dịch
                            </label>
                            <Textbox
                                placeHolder="Nhập tên chiến dịch"
                                value={campaign.title}
                                name="title"
                                id="title"
                                onChanged={(name, value) => {
                                    setCampaign({ ...campaign, title: value });
                                }}
                            />
                        </div>
                        <div className="form-group date-time">
                            <label htmlFor="" className="required">
                                Thời gian diễn ra
                            </label>
                            <div className="list-from-date">
                                <div className="from-date-box">
                                    <TFUDatetime
                                        className="from-date"
                                        name="startTime"
                                        id="startTime"
                                        value={campaign.startTime}
                                        onChanged={(value, name) => {
                                            setCampaign({ ...campaign, startTime: value });
                                        }}
                                        showDateOnly
                                        minDate={new Date()}
                                    />
                                </div>
                                <div className="to-date-box">
                                    <TFUDatetime
                                        className="to-date"
                                        name="endTime"
                                        id="endTime"
                                        value={campaign.endTime}
                                        onChanged={(value, name) => {
                                            setCampaign({ ...campaign, endTime: value });
                                        }}
                                        showDateOnly
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="from-group description">
                            <label htmlFor="" className="required">
                                Mô tả
                            </label>
                            <TextArea
                                placeHolder="Nhập mô tả chiến dịch"
                                value={campaign.description}
                                onChanged={(name, value) => {
                                    setCampaign({ ...campaign, description: value });
                                }}
                            />
                        </div>
                    </div>
                </section>
                <section className="discount-rule">
                    <h6>Thiết lập mã giảm giá</h6>
                    {campaign &&
                        campaign.campaignMegaDeals &&
                        campaign.campaignMegaDeals.map((item, index) => {
                            return (
                                <div className="rule-box" key={index}>
                                    <div className="rule-header">
                                        <div className="rule-header-left">Mức giảm {index + 1}</div>
                                        <div
                                            className="rule-header-right cursor-pointer"
                                            onClick={(e) => {
                                                let newRules = [...campaign.campaignMegaDeals];
                                                newRules.splice(index, 1);
                                                setCampaign({ ...campaign, campaignMegaDeals: newRules });
                                            }}
                                        >
                                            <i className="fa fa-trash"></i>
                                        </div>
                                    </div>
                                    <div className="rule-body">
                                        <div className="list-input-box">
                                            <div className="form-group">
                                                <label htmlFor="">Giá trị đơn hàng tối thiểu</label>
                                                <TextNumber
                                                    placeHolder="Nhập số tiền"
                                                    suffix="đ"
                                                    value={item.minimumOrderValue}
                                                    name={"minimumOrderValue-" + index}
                                                    onChanged={(name, value) => {
                                                        let newRules = [...campaign.campaignMegaDeals];
                                                        newRules[index].minimumOrderValue = value;
                                                        setCampaign({ ...campaign, campaignMegaDeals: newRules });
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="">Loại giảm giá</label>
                                                <TFUSelect
                                                    options={SaleTypeOptions}
                                                    placeholder="Chọn loại giảm giá"
                                                    value={item.saleType}
                                                    onChanged={(value) => {
                                                        let newRules = [...campaign.campaignMegaDeals];
                                                        newRules[index].saleType = value;
                                                        setCampaign({ ...campaign, campaignMegaDeals: newRules });
                                                    }}
                                                    styles={{
                                                        zIndex: 9999,
                                                    }}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="">{item.saleType == SaleType.Percentage ? "Phần trăm giảm giá" : "Giá cố định"}</label>
                                                <TextNumber
                                                    placeHolder="Nhập số tiền"
                                                    suffix={item.saleType == SaleType.Percentage ? "%" : "đ"}
                                                    value={item.saleValue}
                                                    name={"saleValue-" + index}
                                                    onChanged={(name, value) => {
                                                        let newRules = [...campaign.campaignMegaDeals];
                                                        newRules[index].saleValue = value;
                                                        setCampaign({ ...campaign, campaignMegaDeals: newRules });
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}

                    <div className="add-more">
                        <a
                            href=""
                            className="add-rule"
                            onClick={(e) => {
                                e.preventDefault();
                                let newRules = [...campaign.campaignMegaDeals];
                                newRules.push({ ...initCampaignMegaDeal });
                                setCampaign({ ...campaign, campaignMegaDeals: newRules });
                            }}
                        >
                            Thêm mức
                        </a>
                    </div>
                </section>
                <div className="list-bottom-btn">
                    <div className="action-right">
                        <button
                            className="btn btn-clean"
                            onClick={(e) => {
                                e.preventDefault();
                                history.push("/campaign-management");
                            }}
                        >
                            Hủy
                        </button>
                        <button
                            className="btn btn-orange"
                            onClick={(e) => {
                                _handleSave();
                            }}
                        >
                            Hoàn thành
                        </button>
                    </div>
                </div>
            </Wrapper>
        </React.Fragment>
    );
}

export default EditCampaign;

const Wrapper = styled.div`
    width: 1400px;

    .list-bottom-btn {
        display: flex;
        align-items: center;
    }

    .action-right {
        margin-left: auto;
        display: flex;
        align-items: center;
    }

    button.btn.btn-clean {
        border-radius: 40px;
        border: 1px solid #e5e5e5;
        background: #fff;
        color: #303030;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        padding: 12px 30px;
        margin: 0 12px;
    }

    button.btn.btn-orange {
        border-radius: 40px;
        background: #ff9027;
        color: #fff;
        font-family: Roboto;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        padding: 12px 30px;
    }

    section.instruction-section {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff5ec;
        padding: 16px 24px;
        margin: 12px 0;
    }

    .instruction-section p {
        margin: 0;
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }

    section.overview-section {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 24px;
    }

    section.overview-section h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin: 0 0 10px 0;
    }

    .list-form {
        display: flex;
        flex-wrap: wrap;
    }

    .from-group.description {
        width: 100%;
    }

    .form-group.title {
        width: 30%;
        margin-right: 30px;
    }

    .form-group label {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .form-group.title input.form-control {
        border-radius: 8px !important;
        border: 1px solid #e5e5e5;
        background: #fff;
    }

    d {
    }

    .list-from-date {
        display: flex;
        align-items: center;
    }

    .from-date-box {
    }

    .list-from-date input.form-control {
        /* border-radius: 0px 8px 8px 0px; */
        border: 1px solid #e5e5e5;
        background: #fff;
    }

    input.from-date.form-control {
        border-radius: 8px 0px 0px 8px;
    }

    input.to-date.form-control {
        border-radius: 0px 8px 8px 0px;
    }

    .from-group.description textarea.form-control {
        border-radius: 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
    }

    section.discount-rule {
        border-radius: 12px;
        border: 1px solid #f3f3f3;
        background: #fff;
        padding: 24px;
        margin: 12px 0;
    }

    section.discount-rule h6 {
        color: #303030;
        font-family: Lexend;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        margin: 0 0 10px 0;
    }

    .rule-box {
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e5e5e5;
        background: #f8f8f8;
        margin: 12px 0;
    }

    .rule-header {
        display: flex;
        align-items: center;
        padding: 14px 16px;
        border-bottom: 1px solid #e5e5e5;
    }

    .rule-header-right {
        margin-left: auto;
        color: #d70000;
    }

    .rule-header-left {
        color: #303030;
        font-family: Lexend;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
    }

    .rule-body {
        padding: 14px 16px;
    }

    .list-input-box {
        display: flex;
        align-items: center;
    }

    .list-input-box .form-group {
        width: calc(33.33% - 20px);
        margin: 0 40px;
    }

    .list-input-box .form-group:first-child {
        margin-left: 0;
    }

    .list-input-box .form-group input.form-control {
        border-radius: 8px 0 0 8px;
        border: 1px solid #e5e5e5;
        background: #fff;
    }
`;
